const WORKFLOW = {
  PURCHASE: {
    DOCUMENT_TRANSACTED: {
      primary: 'DOCUMENT_ACCEPTED',
      alternatives: ['DOCUMENT_REFUSED', 'DOCUMENT_DISPUTE_STARTED'],
    },
    DOCUMENT_ACCEPTED: {primary: 'DOCUMENT_PAID', alternatives: []},
    DOCUMENT_REFUSED: {primary: 'DOCUMENT_CLOSED', alternatives: []},
    DOCUMENT_DISPUTE_STARTED: {
      primary: 'DOCUMENT_DISPUTE_RESOLVED',
      alternatives: [],
    },
    DOCUMENT_DISPUTE_RESOLVED: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_CLOSED'],
    },
    DOCUMENT_PAID: {primary: 'DOCUMENT_CLOSED', alternatives: []},
  },
  SALE: {
    DOCUMENT_TRANSACTED: {
      primary: 'DOCUMENT_SENT',
      alternatives: [],
    },
    DOCUMENT_SENT: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_1: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_2: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_3: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_4: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_5: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_6: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_7: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_8: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    REMINDER_9: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_DISPUTE_STARTED'],
    },
    DOCUMENT_DISPUTE_STARTED: {
      primary: 'DOCUMENT_DISPUTE_RESOLVED',
      alternatives: [],
    },
    DOCUMENT_DISPUTE_RESOLVED: {
      primary: 'DOCUMENT_PAID',
      alternatives: ['DOCUMENT_CLOSED'],
    },
    DOCUMENT_PAID: {primary: 'DOCUMENT_CLOSED', alternatives: []},
  },
};

const STANDARD_JOURNAL_TYPES = new Set(['FINANCIAL', 'GENERAL']);

const STATUS_ACTION_LABEL_KEYS = {
  DOCUMENT_ACCEPTED: 'hit-app.transaction.status-action.accept',
  DOCUMENT_PAID: 'hit-app.transaction.status-action.pay',
  DOCUMENT_CLOSED: 'hit-app.transaction.status-action.close',
  DOCUMENT_REFUSED: 'hit-app.transaction.status-action.refuse',
  DOCUMENT_DISPUTE_STARTED: 'hit-app.transaction.status-action.dispute',
  DOCUMENT_DISPUTE_RESOLVED:
    'hit-app.transaction.status-action.resolve-dispute',
  DOCUMENT_SENT: 'hit-app.transaction.status-action.mark-sent',
  PEPPOL_INVOICE_RECEIVED: 'hit-app.transaction.status-action.receive-peppol',
  PEPPOL_INVOICE_SENT: 'hit-app.transaction.status-action.send-peppol',
  DOCUMENT_TRANSACTED: 'hit-app.transaction.status-action.transact',
  DOCUMENT_FORWARDED_TO_BOOKKEEPING:
    'hit-app.transaction.status-action.forward-to-bookkeeping',
  DOCUMENT_TRANSACTED_AUTOMATICALLY:
    'hit-app.transaction.status-action.transact-automatically',
  DOCUMENT_SYNCED_WITH_HIT_OFFICE:
    'hit-app.hit-transaction-status.document-synced-with-hit-office',
};

const STATUS_LABEL_KEYS = {
  DOCUMENT_ACCEPTED: 'hit-app.hit-transaction-status.document-accepted',
  DOCUMENT_PAID: 'hit-app.hit-transaction-status.document-paid',
  DOCUMENT_CLOSED: 'hit-app.hit-transaction-status.document-closed',
  DOCUMENT_REFUSED: 'hit-app.hit-transaction-status.document-refused',
  DOCUMENT_DISPUTE_STARTED:
    'hit-app.hit-transaction-status.document-dispute-started',
  DOCUMENT_DISPUTE_RESOLVED:
    'hit-app.hit-transaction-status.document-dispute-resolved',
  DOCUMENT_SENT: 'hit-app.hit-transaction-status.document-sent',
  DOCUMENT_TRANSACTED: 'hit-app.hit-transaction-status.document-transacted',
  PEPPOL_INVOICE_RECEIVED:
    'hit-app.hit-transaction-status.peppol-invoice-received',
  PEPPOL_INVOICE_SENT: 'hit-app.hit-transaction-status.peppol-invoice-sent',
  DOCUMENT_FORWARDED_TO_BOOKKEEPING:
    'hit-app.hit-transaction-status.document-forwarded-to-bookkeeping',
  DOCUMENT_TRANSACTED_AUTOMATICALLY:
    'hit-app.hit-transaction-status.document-transacted-automatically',
  DOCUMENT_SYNCED_WITH_HIT_OFFICE:
    'hit-app.hit-transaction-status.document-synced-with-hit-office',
};

const STATUS_ICONS = {
  DOCUMENT_ACCEPTED: 'verified',
  DOCUMENT_PAID: 'paid',
  DOCUMENT_CLOSED: 'valid',
  DOCUMENT_REFUSED: 'block',
  DOCUMENT_DISPUTE_STARTED: 'work_alert',
  DOCUMENT_DISPUTE_RESOLVED: 'valid',
  DOCUMENT_SENT: 'mail',
  PEPPOL_INVOICE_RECEIVED: 'peppol_in',
  PEPPOL_INVOICE_SENT: 'peppol_out',
  DOCUMENT_FORWARDED_TO_BOOKKEEPING: 'bookkeeping',
  DOCUMENT_TRANSACTED_AUTOMATICALLY: 'send',
  DOCUMENT_SYNCED_WITH_HIT_OFFICE: 'arrow_left_right',
};

for (let level = 1; level <= 9; level += 1) {
  const statusId = `REMINDER_${level}`;
  STATUS_LABEL_KEYS[statusId] =
    `hit-app.hit-transaction-status.reminder-${level}`;
  STATUS_ICONS[statusId] = 'notification';
}

/**
 * Statuses displayed as icons in the history column of the transaction list,
 * in workflow order. Also used to build the column filter, so that the filter
 * options and the icons shown in the column can never drift apart.
 */
export const HISTORY_STATUS_FILTER_OPTIONS = [
  'PEPPOL_INVOICE_RECEIVED',
  'DOCUMENT_SENT',
  'REMINDER_1',
  'REMINDER_2',
  'REMINDER_3',
  'REMINDER_4',
  'REMINDER_5',
  'REMINDER_6',
  'REMINDER_7',
  'REMINDER_8',
  'REMINDER_9',
  'PEPPOL_INVOICE_SENT',
  'DOCUMENT_REFUSED',
  'DOCUMENT_DISPUTE_STARTED',
  'DOCUMENT_DISPUTE_RESOLVED',
  'DOCUMENT_PAID',
  'DOCUMENT_SYNCED_WITH_HIT_OFFICE',
  'DOCUMENT_FORWARDED_TO_BOOKKEEPING',
  'DOCUMENT_CLOSED',
  'DOCUMENT_TRANSACTED_AUTOMATICALLY',
].map((id) => ({
  id,
  key: STATUS_LABEL_KEYS[id],
  icon: STATUS_ICONS[id],
}));

/**
 * Transaction log statuses that lock the document: it can no longer be
 * reopened or edited
 */
export const STATUSES_THAT_DISABLE_TRANSACTION_EDITING = [
  'MAIL_SENT',
  'PEPPOL_INVOICE_SENT',
  'DOCUMENT_SYNCED_WITH_HIT_OFFICE',
  'DOCUMENT_FORWARDED_TO_BOOKKEEPING',
];

export function hasStatusThatDisablesEditing(logs) {
  if (!Array.isArray(logs) || logs.length === 0) {
    return false;
  }
  return logs.some((log) =>
    STATUSES_THAT_DISABLE_TRANSACTION_EDITING.includes(log?.status),
  );
}

const COMMENT_REQUIRED = new Set([
  'DOCUMENT_REFUSED',
  'DOCUMENT_DISPUTE_STARTED',
  'DOCUMENT_DISPUTE_RESOLVED',
  'DOCUMENT_PAID',
]);

export function getCurrentStatus(transaction) {
  if (!transaction) {
    return 'DOCUMENT_CREATED';
  }
  if (transaction.status) {
    return typeof transaction.status === 'object'
      ? transaction.status.id
      : transaction.status;
  }
  if (!transaction.transacted) {
    if (transaction.oldDocumentNumber) {
      return 'DOCUMENT_REOPENED';
    }
    return 'DOCUMENT_CREATED';
  }
  return 'DOCUMENT_TRANSACTED';
}

export function getStatusIcon(statusId) {
  return STATUS_ICONS[statusId] ?? 'check';
}

export function getStatusActionLabel(statusId, t) {
  const key = STATUS_ACTION_LABEL_KEYS[statusId];
  return key ? t(key) : statusId;
}

/** Past-tense label for a completed status (icons, history, filters). */
export function getStatusLabel(statusId, t) {
  const key = STATUS_LABEL_KEYS[statusId];
  return key ? t(key) : statusId;
}

/**
 * Returns workflow UI config for the status split button, or null if hidden.
 */
export function getStatusWorkflowAction(transaction, journalType, t) {
  if (!transaction || !journalType) {
    return null;
  }
  if (
    journalType !== 'PURCHASE' &&
    journalType !== 'SALE' &&
    !STANDARD_JOURNAL_TYPES.has(journalType)
  ) {
    return null;
  }

  const currentStatus = getCurrentStatus(transaction);

  if (currentStatus === 'DOCUMENT_CLOSED') {
    return {hidden: true};
  }

  if (
    currentStatus === 'DOCUMENT_CREATED' ||
    currentStatus === 'DOCUMENT_REOPENED'
  ) {
    return {isValidate: true};
  }

  const step = WORKFLOW[journalType]?.[currentStatus];
  if (!step) {
    return null;
  }

  const primaryLabel = step.primaryLabelKey
    ? t(step.primaryLabelKey)
    : getStatusActionLabel(step.primary, t);

  return {
    isValidate: false,
    primary: step.primary,
    primaryLabel,
    primaryIcon: getStatusIcon(step.primary),
    alternatives: (step.alternatives ?? []).map((id) => ({
      id,
      label: getStatusActionLabel(id, t),
      icon: getStatusIcon(id),
    })),
  };
}

export function isTransitionAllowed(currentStatus, targetStatus, journalType) {
  if (!journalType) {
    return false;
  }
  if (
    journalType !== 'PURCHASE' &&
    journalType !== 'SALE' &&
    !STANDARD_JOURNAL_TYPES.has(journalType)
  ) {
    return false;
  }
  if (
    currentStatus === 'DOCUMENT_CREATED' ||
    currentStatus === 'DOCUMENT_REOPENED'
  ) {
    return targetStatus === 'DOCUMENT_TRANSACTED';
  }
  const step = WORKFLOW[journalType]?.[currentStatus];
  if (!step) {
    return false;
  }
  if (targetStatus === step.primary) {
    return true;
  }
  return (step.alternatives ?? []).includes(targetStatus);
}

export function requiresComment(targetStatus) {
  return COMMENT_REQUIRED.has(targetStatus);
}
